import {format} from "date-fns";

const useOriginalOrAlternativeValue = () => {
  const valueOrEmptyString = (value: string | undefined | null) => {
    return value ?? "";
  };

  const listOrEmptyArray = <T>(list: T[] | undefined): T[] => {
    return list ?? [];
  };

  const valueOrHyphen = (value: string | null | undefined | number) => {
    if (!!value) {
      return value;
    }
    return "-";
  };

  const formatedDateOrHyphen = (value: string | null | undefined) => {
    if (!!value) {
      return format(new Date(value), "dd/MM/yyyy");
    }
    return "-";
  };

  return {
    valueOrEmptyString,
    listOrEmptyArray,
    valueOrHyphen,
    formatedDateOrHyphen,
  };
};

export default useOriginalOrAlternativeValue;
